module.exports = __webpack_public_path__ + "static/media/powered-by-phonic-black.35992d23.png";